export default {
  favicon: true,
  appleTouchIcon: true,
  logo: true,
  title: 'Leadership Toolkit',
  site: 'rr',
  GA_CODE: 'UA-149748939-1',
  locale: 'enDefault',
  rememberMeDefault: true,
  features: {
    SPONSOR_AUTH: false,
  },
};
